// extracted by mini-css-extract-plugin
export default {"panel_cards_container":"styles_panel_cards_container__dt5d3","panel_card":"styles_panel_card__lbAkG"};